import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';

import { IDay, IMainstreetEvent, ICalendarState, MultiLocation } from './classes';
import CalendarDay from './calendar-day';
import CalendarEmptyDay from './calendar-empty-day';
import CalendarPagination from './calendar-pagination';
import { nextMonth, previousMonth, getNextEvents, getPreviousEvents } from './actions';
import * as fetch from 'isomorphic-fetch';

interface ICalendarMonth {
    baseModel: ICalendarState<IMainstreetEvent>;
}

class CalendarMonth extends React.Component<ICalendarMonth, any>{
    CourseAndEventFiltersSelectedMessage: string;
    NoMatchingResultsMessage: string;
    EventGetUrl: string;
    IsLoggedIn: boolean;
    constructor(props) {
        super(props);
        this.IsLoggedIn = (window as any).isLoggedIn;
        this.NoMatchingResultsMessage = (window as any).bootStrappedData.noMatchingResultsMessage;
        this.CourseAndEventFiltersSelectedMessage = (window as any).bootStrappedData.courseAndEventFiltersSelectedMessage;
        this.EventGetUrl = this.getRootUrl() + "cart/AddEvent";
    }

    eventIsMultiLocation(event: IMainstreetEvent): boolean {
        if (!event.location || !event.format)
            return false;
        if (typeof event.location != 'undefined' && event.location.indexOf(",") == -1)
            return false;
        if (typeof event.format != 'undefined' && event.format.indexOf(",") == -1) {
            return false;
        }
        return true;
    }
    getMultipleLocationItems(event: IMainstreetEvent): Array<MultiLocation> {
        let items: Array<MultiLocation> = [];
        var locations = event.location.split(",");
        var formats = event.format.split(",");
        var loopLength = Math.max(locations.length, formats.length);
        for (let i = 0; i < loopLength; i++) {
            var item: MultiLocation = {
                location: '',
                format: ''

            };
            if (typeof locations[i] != 'undefined')
                item.location = locations[i];
            if (typeof formats[i] != 'undefined')
                item.format = formats[i];
            items.push(item);
        }
        return items;

    }
    render() {
        return (
            <div className="calendar-month">
                <div className="calendar-month-grid calendar-events-inner">
                    <div className="calendar-events-header">
                        <h2>{this.props.baseModel.showAllMonths ? "All Months" : this.props.baseModel.startDate.format('MMMM YYYY')}</h2>


                        <CalendarPagination showAllMonths={this.props.baseModel.showAllMonths}
                            hasMoreEvents={this.props.baseModel.hasMoreEvents}
                            previousEventsClick={this.previousEventsClick.bind(this)}
                            previousMonthClick={this.previousMonthClick.bind(this)}
                            nextEventsClick={this.nextEventsClick.bind(this)}
                            nextMonthClick={this.nextMonthClick.bind(this)}
                            startDate={this.props.baseModel.startDate}
                            events={this.props.baseModel.events}
                            offset={this.props.baseModel.offset}
                            className={"calendar-icon-chevrons-container " + ((this.props.baseModel.showAllMonths && this.props.baseModel.events.length < 1) ? "hide" : "show")}
                        />

                    </div>

                    <div className={"calendar-loading-container " + (this.props.baseModel.updating ? "" : "calendar-hide")}>
                        <svg className="svg-icon calendar-loading-spinner" aria-hidden="true" focusable="false">
                            <g transform="translate(-1177 -2790)">
                                <use xlinkHref="#path0Fill" transform="translate(1177 2790)" fill="#EEEEEE" />
                                <use xlinkHref="#path1Fill" transform="translate(1177 2790)" fill="#213556" />
                                <use xlinkHref="#path2Fill" transform="translate(1177 2790)" fill="#213556" />
                                <use xlinkHref="#path3Fill" transform="translate(1206 2790)" fill="#EF6362" />
                                <use xlinkHref="#path4Fill" transform="translate(1206 2790)" fill="#EF6362" />
                                <use xlinkHref="#path5Fill" transform="translate(1206 2790)" fill="#EF6362" />
                            </g>
                        </svg>
                        <h4>Loading More Courses &amp; Events</h4>
                    </div>

                    {
                        this.props.baseModel.events.length > 0 &&
                        <div>
                            {this.props.baseModel.events.map(event => {
                                return (
                                    <div className="calendar-event" key={event.id}>
                                        <div className="calendar-event-info">
                                            <div className="calendar-event-date-time">
                                                <div>
                                                    <h5><span className="event-date">{event.eventDateString}</span><span className="circle-red"> </span><span className="event-time">{event.eventTimeString}</span></h5>
                                                </div>
                                                <div className="calendar-event-tag" href="#">
                                                    <svg className={"svg-icon " + (event.isMemberOnly && !(window as any).isLoggedIn ? "" : "svg-icon-hidden")} aria-hidden="true" focusable="false">
                                                        <g transform="translate(-603 -3892)">
                                                            <use xlinkHref="#icon-locked-path-one" transform="translate(608 3894)" />
                                                            <use xlinkHref="#icon-locked-path-two" transform="translate(608 3894)" />
                                                        </g>
                                                    </svg>
                                                    <svg className={"svg-icon " + (event.isMemberOnly && (window as any).isLoggedIn ? "" : "svg-icon-hidden")} aria-hidden="true" focusable="false">
                                                        <g transform="translate(-2085 -40)">
                                                            <use xlinkHref="#icon-unlocked-path-one" transform="translate(2090 42)" />
                                                            <use xlinkHref="#icon-unlocked-path-two" transform="translate(2090 42)" />
                                                        </g>
                                                    </svg>
                                                    <span className="text">
                                                        <span className="visually-hidden">Members only icon. </span>
                                                    </span>
                                                    {event.category}
                                                </div>
                                            </div>

                                            <a href={event.detailPageLink}>
                                                <h3 className="calendar-event-title">{event.name}</h3>
                                            </a>
                                            <div className="calendar-event-details">
                                                {this.eventIsMultiLocation(event)
                                                    ?
                                                    this.getMultipleLocationItems(event).map(value => {
                                                        return (
                                                            <div>
                                                                <p>{value.location} <span className="circle-black"></span>{value.format}</p>
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    <div>
                                                        <p>{event.location}</p>
                                                        <p><span className="circle-black"></span>{event.format}</p>
                                                    </div>
                                                }

                                                <p className="calendar-event-speaker">{event.instructor}</p>
                                            </div>
                                            <div className="calendar-event-buy-tickets">
                                                <span className="calendar-event-buy-tickets-btn">
                                                    {(event.isAvailable)
                                                        ?
                                                        (event.buyTicketsLink.trim() != "" ?
                                                            <a className={"btn calendar-event-btn " + (event.disableRegister ? "btn-disabled" : "")} href={event.buyTicketsLink}>{event.buyTicketsText}</a>
                                                            :
                                                            <a className={"btn calendar-event-btn " + (event.disableRegister ? "btn-disabled" : "")} href={(!this.IsLoggedIn && event.isMemberOnly ? "/login?returnUrl=~/cart?EventId=" + event.id : this.EventGetUrl + "?EventId=" + event.id + "&Amount=" + event.memberPrice.replace('$', '') + "&IsMemberOnly=" + event.isMemberOnly)}>{(!this.IsLoggedIn && event.isMemberOnly ? "Sign in to Register" : event.buyTicketsText)}</a>
                                                        )
                                                        :
                                                        <p className={"font-coral"}>{event.availablityErrorMessage}</p>
                                                    }

                                                </span>
                                                <span className="calendar-event-buy-tickets-info">
                                                    <p className={"calendar-event-member " + (event.showMemberPrice ? "" : "element-hidden")}>{event.memberPrice} Members</p>
                                                    <div className={"circle-gray " + (event.isMemberOnly ? "element-hidden" : "")}></div>
                                                    <p className={"calendar-event-non-member " + (event.isMemberOnly ? "element-hidden" : "")}>{event.nonMemberPrice} Non-Members</p>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="calendar-event-image-container">
                                            <div className="calendar-event-image" style={{ backgroundImage: 'url(' + event.thumbnailUrl + ')' }} />
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>
                    }

                    {this.renderError()}

                    <CalendarPagination showAllMonths={this.props.baseModel.showAllMonths}
                        hasMoreEvents={this.props.baseModel.hasMoreEvents}
                        previousEventsClick={this.previousEventsClick.bind(this)}
                        previousMonthClick={this.previousMonthClick.bind(this)}
                        nextEventsClick={this.nextEventsClick.bind(this)}
                        nextMonthClick={this.nextMonthClick.bind(this)}
                        startDate={this.props.baseModel.startDate}
                        events={this.props.baseModel.events}
                        offset={this.props.baseModel.offset}
                        className={"calendar-icon-chevrons-container-bottom " +
                            (this.props.baseModel.events.length < 1 ? "hide" : "show")}
                    />


                </div>
            </div>
        );
    }

    get hasError() {
        return this.props.baseModel.events.length <= 0 && !this.props.baseModel.updating;
    }

    get CourseAndEventSelected(): boolean {
        return this.props.baseModel.courseTypeFilter.length > 0 && this.props.baseModel.eventTypeFilter.length > 0;
    }

    // WYSIWYG properties are encoded to facilitate bootstrapping to page and must be converted back to html
    decodeHtml = (text: string) => {
        let textElement = document.createElement('textarea');
        textElement.innerHTML = text;
        return textElement.value;
    }

    renderError = () => {
        if (!this.hasError) return null;
        
        let message = this.CourseAndEventSelected ? this.CourseAndEventFiltersSelectedMessage : this.NoMatchingResultsMessage;

        return (
            <div className="calendar-filters-error">
                <div dangerouslySetInnerHTML={{ __html: this.decodeHtml(message) }} />
            </div>
        );
    }

    formatDate(date: Date): string {
        var mom = moment(date);
        return mom.format("MMM") + " " + mom.format("D");
    }
    getRootUrl(): string {
        return window.location.origin ? window.location.origin + '/' : window.location.protocol + '/' + window.location.host + '/';
    }
    nextMonthClick() {
        this.props.baseModel.dispatch(nextMonth());
    }

    previousMonthClick() {
        this.props.baseModel.dispatch(previousMonth());
    }

    nextEventsClick() {
        this.props.baseModel.dispatch(getNextEvents(this.props.baseModel.offset));
    }

    previousEventsClick() {
        this.props.baseModel.dispatch(getPreviousEvents(this.props.baseModel.offset));
    }
}

export default CalendarMonth;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/calendar-month.tsx